import './polyfills';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/oswald/wght.css';
import { App } from './App';
import { ErrorBoundary } from './components/primitives/ErrorBoundary';
import { reportError, setupAnalytics } from './observability';
import { setupPWA } from './pwa/registerSW';

setupAnalytics();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const onReactError = (error: unknown, errorInfo: { componentStack?: string | null | undefined }) =>
  reportError(error as Error, { componentStack: errorInfo.componentStack });

createRoot(rootEl, {
  onUncaughtError: onReactError,
  onCaughtError: onReactError,
}).render(
  <StrictMode>
    <ErrorBoundary onError={reportError}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

void setupPWA();
